/**
 * 
 */
const Renderer = L.MaskRenderer = L.Canvas.extend({
  /**
   * 
   */
  getEvents() {
    var events = L.Renderer.prototype.getEvents.call(this);
    events.viewprereset = this._onViewPreReset;
    events.move = L.Util.throttle(this._update, 60, this); // 拖拽平移地图时，刷新
    return events;
  },
  /**
   * 
   */
  _updatePoly(layer, closed) {
    let {
      _ctx: ctx,
      _container
    } = this;
    let {
      options
    } = layer;
    let {
      _leaflet_pos
    } = _container;
    // 
    // let bounds = this._bounds;
    // let size = bounds.getSize();
    // let pos = bounds.min;
    // let m = L.Browser.retina ? 2 : 1;
    // 
    // 设置遮罩层
    ctx.save();
    if (this._containerCopy) { //  拖拽的应对措施，重置transform
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    ctx.clearRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
    ctx.beginPath();
    ctx.fillStyle = options.fillColor;
    ctx.fillRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
    ctx.restore();
    // 反向遮罩
    let prev = ctx.globalCompositeOperation;
    ctx.globalCompositeOperation = "destination-out";
    let fillColor = options.fillColor;
    options.fillColor = '#000';
    L.Canvas.prototype._updatePoly.call(this, layer, closed);
    ctx.globalCompositeOperation = prev;
    // 绘制边界线
    options.fill = false;
    L.Canvas.prototype._updatePoly.call(this, layer, closed);
    // 还原
    options.fill = true;
    options.fillColor = fillColor;
  }
})
/**
 * 
 */
L.Mask = L.Polygon.extend({
  options: {
    interactive: true,
    weight: 2,
    color: '#042847',
    fillOpacity: 1,
    fillColor: 'rgba(0,26,51,.7)',
    shadowBlur: 5,
    shadowColor: '#042847',
    // renderer: new Renderer((!options || !options.interactive) && {
    //   pane: 'tilePane'
    // })
  },
  /**
   * @override
   */
  beforeAdd(map) {
    let {
      options
    } = this;
    options.renderer = options.renderer || new Renderer((!options || !options.interactive) && {
      pane: 'tilePane'
    })
    this._renderer = map.getRenderer(this);
  },
  /**
   * @override
   */
  _project() {
    L.Polygon.prototype._project.call(this);

    this.__pxBounds = this._pxBounds;
    let bounds = this._map.getBounds();
    let northWest = bounds.getNorthWest();
    let southEast = bounds.getSouthEast();

    this._pxBounds = L.bounds(this._map.latLngToLayerPoint(northWest), this._map.latLngToLayerPoint(southEast));
  },
  /**
   * 支持事件
   */
  _containsPoint(p) {
    let _pxBounds = this._pxBounds;
    this._pxBounds = this.__pxBounds;
    let result = L.Polygon.prototype._containsPoint.call(this, p);
    this._pxBounds = _pxBounds;
    return result;
  }
})

L.mask = (latlngs, options) => new L.Mask(latlngs, options);



// WEBPACK FOOTER //
// ./src/feature/Mask.js